<span i18n="common.words|Go To Label@@gotoLabel">Go to</span>&nbsp;<ng-content
></ng-content>
